import SalesStageContainer from './sales-stage-container';

export default SalesStageContainer;
